import { defineStore } from "pinia";
import axios from "@/axios.js";
import endpoints from "@/endpoints";
import store from "@/store/index";

function getShortValueFromType(type) {
    const shortValue = {
        motherline: "mtdna",
        fatherline: "ydna",
    }[type];
    if (!shortValue) {
        throw Error(`Could not determine short value for ${type}`);
    }
    return shortValue;
}

const parentalStoreOptions = (type) => ({
    state() {
        return {
            result: {},
            activeRegion: "",
        };
    },
    actions: {
        async getResult() {
            await axios.get(`${endpoints.tests}/${store.getters.profile.profile.barcode}/${type}`).then(response => {
                if ( response.data ) {
                    const result = response.data.testData[getShortValueFromType(type)].results;
                    result.migrationPaths = result.migrationPaths.map(({migrationPath, ...properties}) => ({
                        migrationPath: JSON.parse(migrationPath),
                        ...properties
                    }));
        
                    this.result = result;
                } else {
                    this.result = {};
                }
            }).catch(err => {
                this.result = {};
                console.log('Error', err);
            })            
        },
    },
    persist: false, // Add this line to enable persistence
});

export const useMotherlineStore = defineStore(
    "motherlineStore",
    parentalStoreOptions("motherline")
);

export const useFatherlineStore = defineStore(
    "fatherlineStore",
    parentalStoreOptions("fatherline")
);
